import { DOWNLOAD_APP_URL } from '../../constants'
import { store } from '../../store'

// date format will be in dayjs
export const getDateStr = (date = {}) => {
  return `${date['$y']}-${date['$M'] + 1}-${date['$D']}`
}

export const parseQueryString = (queryString) => {
  var params = {}
  var queryStringWithoutQuestionMark = queryString.substring(1) // Remove the leading '?'
  var keyValuePairs = queryStringWithoutQuestionMark.split('&')

  for (var i = 0; i < keyValuePairs.length; i++) {
    var keyValuePair = keyValuePairs[i].split('=')
    var key = decodeURIComponent(keyValuePair[0])
    var value =
      keyValuePair.length > 1 ? decodeURIComponent(keyValuePair[1]) : null

    params[key] = value
  }

  return params
}

export const getUrlParams = () => {
  if (typeof window !== 'undefined') {
    return parseQueryString(window.location.search)
  } else {
    return {}
  }
}

export const removeUrlParam = (paramKey) => {
  if (typeof window !== 'undefined') {
    const url = new URL(window.location.href)
    url.searchParams.delete(paramKey)
    window.history.replaceState({}, '', url.toString())
  }
}

export const checkUserPlanFree = (patientPlans) => {
  if (!patientPlans || patientPlans?.length == 0) {
    return true
  } else if (patientPlans?.[0]?.plan_type == 'Free') {
    return true
  }
  return false
}

export const getThumbnail = async (item) => {
  const { fs } = ReactNativeBlobUtil
  const {
    dirs: { DownloadDir, DocumentDir },
  } = fs

  const directoryPath = Platform.select({
    ios: DocumentDir,
    android: DownloadDir,
  })

  const filePath = `${directoryPath}/${item?.title}`
  const exists = await fs.exists(filePath)

  if (exists) {
    await fs.unlink(filePath)
  }

  const configOptions = Platform.select({
    ios: {
      // fileCache: true,
      path: filePath,
      appendExt: 'pdf',
      notification: true,
    },
    android: {
      // fileCache: true,
      appendExt: 'pdf',
      addAndroidDownloads: {
        useDownloadManager: true,
        title: item?.title,
        mediaScannable: true,
        path: filePath,
      },
    },
  })
  try {
    const data = await ReactNativeBlobUtil.config(configOptions).fetch(
      'GET',
      item?.document_url?.[0],
    )

    const filePath = data.path()
    const fileExists = await ReactNativeBlobUtil.fs.exists(filePath)

    if (!fileExists) {
      throw new Error(`File does not exist at path: ${filePath}`)
    }

    const thumbnailUri = await generateThumbnailFromPdf({
      mime: 'application/pdf',
      path: data.path(),
      name: item?.title,
    })
    return thumbnailUri
  } catch (error) {
    console.log('[PDF FILE ERROR]: ', error)
    throw new Error()
  }
}

export const getAddressComponents = (addressComponents) => {
  const address = {}
  //  houseNumber should include plus_code, sublocality, locality, administrative_area_level_3 - prepare in this format
  addressComponents.forEach((component) => {
    if (component.types.includes('postal_code')) {
      address.pincode = component.long_name
    } else if (component.types.includes('country')) {
      address.country = component.long_name
    } else if (component.types.includes('administrative_area_level_1')) {
      address.state = component.long_name
    } else if (component.types.includes('locality')) {
      address.city = component.long_name
    } else if (
      component.types.includes('administrative_area_level_2') &&
      !address.city
    ) {
      address.city = component.long_name
    } else if (component.types.includes('plus_code')) {
      address.houseNumber = component.long_name
    } else if (component.types.includes('sublocality')) {
      address.sublocality = component.long_name
    } else if (component.types.includes('locality')) {
      address.locality = component.long_name
    } else if (component.types.includes('administrative_area_level_3')) {
      address.administrative_area_level_3 = component.long_name
    } else if (component.types.includes('route')) {
      address.street = component.long_name
    }
  })

  const components = [
    address.houseNumber,
    address.sublocality,
    address.locality,
    address.administrative_area_level_3,
  ].filter(Boolean) // This removes any undefined or null values

  address.houseNumber = components.join(', ')

  return address
}

export const getActivePatientPlan = (plans = []) => {
  const currentDate = new Date()
  const validPlans = plans.filter(
    (plan) => new Date(plan.expiry_date) > currentDate,
  )
  return validPlans[0] || null
}

export const isInApp = () => {
  return Boolean(window?.ReactNativeWebView)
}

export const isInWeb = () => {
  return !isInApp()
}

export const getToken = async () => {
  try {
    const {
      auth: { patientDetails, verifyOtp },
      authentication: { userDetailsState },
    } = store.getState()
    const token =
      userDetailsState?.data?.token ||
      patientDetails?.data?.token ||
      verifyOtp?.data?.data?.token ||
      localStorage.getItem('auth_token')
    if (token !== null) {
      // token previously stored
      return token
    }
  } catch (e) {
    throw new Error('Token not found or could not be retrieved')
  }
}

export const downloadApp = () => {
  window.location.replace(DOWNLOAD_APP_URL)
}

export const getEncodedDataFromUrl = () => {
  const urlParams = Object.fromEntries(
    new URLSearchParams(window.location.search).entries(),
  )

  let paramsData = {}
  try {
    paramsData = JSON.parse(decodeURIComponent(urlParams?.data || '{}'))
  } catch {
    paramsData = {}
  }
  return paramsData
}
